import React, { useState } from 'react';
import HealthSummaryCard from './HealthSummaryCard';
import HealthGuideCard from './HealthGuideCard';
import BodyOverview from './BodyOverview';
import HealthDataSection from './HealthDataSection';
import '../styles/ChatInterface.css';

const ChatInterface: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'overview' | 'records'>('overview');
  const [showTextInput, setShowTextInput] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [inputText, setInputText] = useState('');
  const [showBodyOverview, setShowBodyOverview] = useState(false);

  const handleSendMessage = () => {
    if (inputText.trim()) {
      console.log('发送消息:', inputText);
      setInputText('');
      setShowTextInput(false);
    }
  };

  const handleVoicePress = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    setIsRecording(true);
    
    // 模拟录音结束
    setTimeout(() => {
      setIsRecording(false);
    }, 2000);
  };

  const handlePhotoSelect = () => {
    console.log('拍照');
  };

  const handleAlbumSelect = () => {
    console.log('从相册选择');
  };

  // 如果显示身体概览，渲染身体概览界面
  if (showBodyOverview) {
    return (
      <BodyOverview onBack={() => setShowBodyOverview(false)} />
    );
  }

  return (
    <div className="chat-container">
      {/* 顶部Tab导航 - 去掉图标 */}
      <div className="tab-navigation">
        <div className="tab-container">
          <button 
            className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            健康助手
          </button>
          <button 
            className={`tab-button ${activeTab === 'records' ? 'active' : ''}`}
            onClick={() => setActiveTab('records')}
          >
            健康档案
          </button>
        </div>
      </div>
      
      {/* 内容区域 */}
      <div className="chat-content">
        {activeTab === 'overview' && (
          <>
            <HealthSummaryCard onViewBodyOverview={() => setShowBodyOverview(true)} />
            <HealthGuideCard />
          </>
        )}

        {activeTab === 'records' && (
          <div className="records-content">
            <HealthDataSection className="chat-health-data" />
          </div>
        )}
      </div>
      
      {/* 底部工具栏 - 仅在我的档案页面显示 */}
      {activeTab === 'overview' && (
        <div className="bottom-toolbar">
        {showTextInput && (
          <div className="text-input-overlay">
            <div className="input-wrapper">
              <input
                type="text"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                placeholder="输入您的问题..."
                className="chat-input"
                onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                autoFocus
              />
              <button 
                onClick={handleSendMessage}
                className="send-button"
                disabled={!inputText.trim()}
              >
                发送
              </button>
            </div>
            <button 
              className="close-input-button"
              onClick={() => setShowTextInput(false)}
            >
              ✕
            </button>
          </div>
        )}
        
        <div className="toolbar-container-new">
          {/* 语音按钮 - 去掉图标 */}
          <button 
            className={`voice-button-new ${isRecording ? 'recording' : ''}`}
            onMouseDown={handleVoicePress}
            onTouchStart={handleVoicePress}
          >
            <span className="voice-text-new">{isRecording ? '正在录音...' : '长按说话'}</span>
            {isRecording && <div className="recording-animation-new"></div>}
          </button>
          
          {/* 工具按钮组 - 移到下方 */}
          <div className="tool-buttons-new">
            <button 
              className="tool-button-new"
              onClick={() => setShowTextInput(true)}
              title="文字输入"
            >
              <span className="tool-icon-new">⌨️</span>
              <span className="tool-label-new">键盘</span>
            </button>
            <button 
              className="tool-button-new"
              onClick={handlePhotoSelect}
              title="拍照"
            >
              <span className="tool-icon-new">📷</span>
              <span className="tool-label-new">拍照</span>
            </button>
            <button 
              className="tool-button-new"
              onClick={handleAlbumSelect}
              title="从相册选择"
            >
              <span className="tool-icon-new">📁</span>
              <span className="tool-label-new">相册</span>
            </button>
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default ChatInterface;